import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import About from '@/views/About'
import News from '@/views/News'
import NewsDetail from '@/views/NewsDetail'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { title: 'Home' }
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: { title: 'About us' }
    },
    {
      path: '/news',
      name: 'News',
      component: News,
      meta: { title: 'News' }
    },
    {
      path: '/news/:id',
      name: 'NewsDetail',
      component: NewsDetail,
      meta: { title: 'Responsibility' }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// 工具函数：判断是否为“重复导航”错误
const isDuplicatedNavigation = (err) => {
  return Router.isNavigationFailure(
    err,
    Router.NavigationFailureType.duplicated
  )
}

// 重写 push 方法：仅忽略完全相同的导航错误
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  // 处理带回调的情况
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }

  // 解析目标路由和当前路由，对比 fullPath（含路径+参数）
  const targetRoute = this.resolve(location).route
  const currentRoute = this.currentRoute
  const isSameNavigation = targetRoute.fullPath === currentRoute.fullPath

  // 捕获错误：仅忽略“完全相同且重复导航”的错误
  return originalPush.call(this, location).catch(err => {
    if (isSameNavigation && isDuplicatedNavigation(err)) {
      // 完全相同的重复导航，忽略错误
      return err
    }
    // 其他错误（如参数不同的导航失败）正常抛出
    return Promise.reject(err)
  })
}

// 补充重写 replace 方法（与 push 逻辑一致）
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }

  const targetRoute = this.resolve(location).route
  const currentRoute = this.currentRoute
  const isSameNavigation = targetRoute.fullPath === currentRoute.fullPath

  return originalReplace.call(this, location).catch(err => {
    if (isSameNavigation && isDuplicatedNavigation(err)) {
      return err
    }
    return Promise.reject(err)
  })
}

export default router
    